import type { ru } from './ru';

export const kk: Record<keyof typeof ru, string> = {
  'errors.E00.unauthorized': 'Жүйеге кіру қажет',
  'errors.E00.forbidden': 'Бұл әрекетке құқық жеткіліксіз',
  'errors.E00.not_found': 'Жазба табылмады',
  'errors.E00.validation_failed': 'Деректер дұрыс толтырылмаған',
  'errors.E00.identity_conflict': 'Автокөлік басқа клиентпен байланысқан',
  'errors.E00.idempotency_required': 'Бұл операция үшін идемпотенттік кілт міндетті',
  'errors.E00.idempotency_mismatch': 'Дәл сол кілт басқа деректермен қолданылған',
  'errors.E00.totp_required': 'Екінші факторды растау қажет',
  'errors.E00.totp_invalid': 'Растау коды дұрыс емес',
  'errors.E00.account_locked': 'Тіркелгі {until} дейін уақытша бұғатталған',
  'errors.E00.site_required': 'Нысан таңдалмаған',
  'errors.E00.shift_required': 'Нысанда ашық ауысым жоқ',
  'errors.E00.shift_closed':
    'Ауысым жабылған. Құрылғы ескі ауысыммен жұмыс істеп тұр — күйін жаңартып, қайталаңыз.',
  'errors.E00.sync_rejected': 'Синхрондау операциясы қабылданбады',
  'errors.E00.conflict': 'Деректер қайшылығы',
  'errors.E00.rate_limited': 'Сұраныс тым көп, кейінірек қайталаңыз',
  'errors.E00.internal': 'Ішкі қате. Әкімшіге хабарласыңыз',
  'errors.E00.password_too_short': 'Құпия сөз {min} таңбадан қысқа',
  'errors.E00.password_too_simple': 'Құпия сөзде кемінде екі түрлі таңба болуы керек: кіші, бас әріптер, сандар, белгілер',
  'errors.E00.login_taken': 'Мұндай логин бос емес',
  'errors.E00.pin_invalid': 'PIN — 4-тен 8-ге дейінгі сан',
  'errors.E00.role_not_grantable': 'Сізге бұл рөлді беруге рұқсат жоқ',
  'errors.E00.employee_not_found': 'Қызметкер табылмады',
  'errors.E00.last_admin': 'Бұл — желінің соңғы әкімшісі, желіні басқарусыз қалдыруға болмайды',
  'errors.E00.totp_enrollment_required': 'Сіздің рөліңіз үшін екінші фактор қажет. Аутентификатор қосымшасын қосыңыз',
  'errors.E00.wrong_password': 'Ағымдағы құпия сөз қате көрсетілген',
  'errors.E00.self_forbidden': 'Өз рөлдеріңіз бен мәртебеңізді өзгертуге болмайды',
  'errors.E00.site_code_taken': '{code} коды бар нысан бұрыннан бар',
  'errors.E00.site_has_open_shift': 'Нысанда ашық ауысым бар — алдымен оны жабыңыз',
  'errors.E00.totp_already_enrolled':
    'Екінші фактор қосылып қойған. Оны ағымдағы кодпен кіргеннен кейін немесе әкімші арқылы қалпына келтіріп ауыстыруға болады',
  'errors.E00.site_forbidden': 'Жазба сізге рұқсат жоқ нысанға тиесілі',
  'errors.E00.login_failed':
    'Логин немесе құпия сөз қате. Бес қатеден кейін кіру 15 минутқа жабылады',
  'errors.E00.payload_too_large': 'Сұраныс тым үлкен: {limit} байттан аспауы керек',
  'errors.E00.pin_trivial': 'PIN тым қарапайым: бірдей сандарды, 1234 және қайталауларды қолданбаңыз',
  'errors.E00.totp_locked':
    'Қате кодтар тым көп. Екінші факторды тексеру 15 минутқа жабылды, кейінірек қайта кіріңіз',
  'errors.E00.device_unknown': 'Құрылғы тіркелмеген. Оны әкімшілік панельде нысанға байлаңыз',
  'errors.E00.device_revoked': 'Құрылғының рұқсаты кері қайтарылды. Әкімшіге хабарласыңыз',
  'errors.E00.parent_rejected':
    'Операция қабылданбаған операцияға тәуелді: {ref}. Бастапқы операцияны қарап, әрекетті қайталаңыз',
  'errors.E00.consent_required': 'Клиенттің дербес деректерді өңдеуге келісімі қажет',
  'errors.E00.merge_invalid': 'Біріктіру мүмкін емес: {reason}',
  'errors.E02.webhook_unauthorized': 'Камера колбэгі құпия сөз тексерісінен өтпеді',
  'errors.E02.site_not_configured': 'Нысан үшін нөмірлерді тану бапталмаған',
  'errors.E02.camera_unknown': '{camera} камерасы нысанда тіркелмеген',
  'errors.E02.vendor_unknown': 'Танудың белгісіз жеткізушісі: {vendor}',
  'errors.E02.vendor_unavailable': 'Тану жеткізушісі қолжетімсіз, қолмен енгізу арқылы жұмыс істеңіз',
  'errors.E02.payload_invalid': 'Камера колбэгін талдау мүмкін болмады',
  'errors.E02.recognition_not_found': 'Тану табылмады',
  'errors.E02.already_acknowledged': 'Бұл тану бойынша көрсетілім бұрын расталған',
  'errors.E02.threshold_invalid': 'Сенімділік шегі 0 мен 1 аралығында болуы тиіс',
  'errors.E02.window_invalid': 'Дедупликация терезесі оң сан болуы тиіс',
  'errors.E05.plan_not_found': 'Тарифтік жоспар табылмады',
  'errors.E05.plan_code_conflict': '{code} кодты жоспар бұрыннан бар',
  'errors.E05.plan_archived': 'Жоспар сатудан алынды, ол бойынша рәсімдеу мүмкін емес',
  'errors.E05.plan_in_use': 'Жоспар бойынша қолданыстағы жазылымдар бар, оны жою мүмкін емес — тек сатудан алу',
  'errors.E05.subscription_not_found': 'Жазылым табылмады',
  'errors.E05.subscription_exists': 'Бұл автокөлікте осы жоспар бойынша жазылым бұрыннан бар',
  'errors.E05.transition_not_allowed': '«{from}» күйінен «{to}» күйіне өту қарастырылмаған',
  'errors.E05.not_active': 'Жазылым белсенді емес: ағымдағы күйі «{status}»',
  'errors.E05.already_charged': '{period} кезеңі үшін есептен шығару өткізілген',
  'errors.E05.charge_failed': 'Есептен шығару өтпеді: {reason}',
  'errors.E05.charge_attempts_exhausted': 'Есептен шығару әрекеттері таусылды: {max} ішінен {attempts}',
  'errors.E05.vehicle_mismatch': 'Жазылым басқа автокөлікке рәсімделген',
  'errors.E05.limit_exceeded': 'Жазылым бойынша жуу лимиті таусылды: {limit} ішінен {used} пайдаланылды',
  'errors.E05.too_frequent': 'Бұл жазылым бойынша тым жиі пайдалану: келесісі {next} уақытынан ерте емес',
  'errors.E05.usage_visit_mismatch': 'Келу басқа автокөлікке қатысты',
  'errors.E05.conversion_would_lose_value': 'Аудару төленген көлемді азайтар еді: {before} болды, {after} болар еді',
  'errors.E05.conversion_already_done': '{ref} абонементі жазылымға аударылған',
  'errors.E05.customer_not_found': 'Клиент табылмады',
  'errors.E05.vehicle_not_found': 'Автокөлік табылмады',
  'errors.E05.period_invalid': 'Есеп кезеңі қате берілген',
  'errors.E05.gateway_unavailable': 'Төлем арнасы қолжетімсіз, кейінірек қайталаңыз',
  'errors.E12.device_not_found': 'Құрылғы түгендеуде табылмады',
  'errors.E12.device_already_revoked': 'Құрылғының рұқсаты бұрын қайтарып алынған',
  'errors.E12.site_not_found': 'Нысан табылмады',
  'errors.E12.release_not_found': 'Шығарылым табылмады',
  'errors.E12.release_running': '{channel} контурында шығарылым жүріп жатыр',
  'errors.E12.release_not_rollbackable':
    'Кері қайтару мүмкін емес: шығарылым «{status}» күйінде немесе қайтару нүктесі жазылмаған',
  'errors.E12.backup_not_found': 'Сақтық көшірме табылмады',
  'errors.E12.backup_running': 'Сақтық көшіру орындалып жатыр',
  'errors.E12.backup_incomplete': 'Көшірме аяқталмаған, ол бойынша жаттығу өткізуге болмайды',
  'errors.E12.drill_failed': 'Қалпына келтіру жаттығуы өтпеді: {mismatches} алшақтық',
  'errors.E12.restore_target_busy': 'Жаттығуға арналған дерекқор алдыңғы іске қосумен бос емес',
  'errors.E12.service_not_found': '{code} сыртқы қызметі тізілімде жоқ',
  'errors.E12.residency_violation':
    'Қызмет дербес деректерді ҚР-дан тыс өңдейді және жіберілмейді (ТТ 8.4)',
  'errors.E12.metrics_unauthorized': 'Метрикаға қол жеткізу токені дұрыс емес',
  'errors.E12.metric_unknown': 'Белгісіз көрсеткіш: {metric}',
  'errors.E12.threshold_invalid': 'Шек дұрыс берілмеген',
  'errors.E12.period_invalid': 'Есеп кезеңі дұрыс берілмеген',
  'errors.E12.pg_tool_missing':
    'pg_dump және pg_restore утилиталары қолжетімсіз. MOIKA_PG_TOOL_PREFIX орнатыңыз немесе postgresql-client орнатыңыз',
  'errors.E08.period_invalid': 'Есеп кезеңі қате берілген',
  'errors.E08.period_too_wide': 'Кезең тым кең: {max} шектеуінде {days} күн',
  'errors.E08.site_required': 'Нысан көрсетілмеген, рөлде қолжетімді нысан жоқ',
  'errors.E08.dataset_unknown': '«{dataset}» деректер жиыны жоқ',
  'errors.E08.export_pii_forbidden': '«{dataset}» жүктемесінде дербес деректер бар, бөлек құқық қажет',
  'errors.E08.policy_invalid': 'Метрика баптауының мәні жарамсыз: {field}',
  'errors.E08.report_timeout': 'Есеп {limit} мс ішінде үлгермеді және тоқтатылды',

  'identification.reason.required': 'Сәйкестендіруден бас тарту себебін таңдаңыз',
  'identification.declined': 'Клиент сәйкестендіруден бас тартты',

  'role.cashier': 'Кассир',
  'role.operator': 'Оператор',
  'role.site_manager': 'Нысан басқарушысы',
  'role.marketer': 'Маркетолог',
  'role.network_admin': 'Желі әкімшісі',
  'role.auditor': 'Аудитор',

  'common.yes': 'Иә',
  'common.no': 'Жоқ',
  'common.save': 'Сақтау',
  'common.cancel': 'Болдырмау',
  'common.loading': 'Жүктелуде…',
  'common.site': 'Нысан',
  'common.network': 'Бүкіл желі',
};
